import { useState } from 'react';
import { toast } from 'react-toastify';
import { TenantInfo } from '~/containers/RentRoll/TenantRentRollTable';

export const useTenantCsvMapping = () => {
  const [fieldMapping, setFieldMapping] = useState<any>({});

  const columnNameSelected = (e: React.ChangeEvent<any>) => {
    setFieldMapping({
      ...fieldMapping,
      [e.target.id]: e.target.value
    });
  };

  const getTargetedRows = (rows: any[], selectedRowId: string) => {
    const index = rows.findIndex((row) => row.id == selectedRowId);
    return rows.slice(index);
  };

  const withFirstAndLastName = (tenant: TenantInfo) => {
    if (tenant.fullName && !tenant.firstName && !tenant.lastName) {
      const [firstName, ...lastName] = tenant.fullName.split(' ');
      tenant.firstName = firstName;
      tenant.lastName = lastName.join(' ');
    }
    return tenant;
  };

  const checkIfEmailColumnIsSelected = () => {
    const selectedFields = Object.values(fieldMapping);
    if (!selectedFields.includes('email')) {
      toast.error('Email column not selected from column match table');
      throw Error('email not selected from column match table');
    }
  };

  const checkIfBuildingNameColumnIsSelected = () => {
    const selectedFields = Object.values(fieldMapping);
    if (!selectedFields.includes('buildingName')) {
      toast.error('Building name column not selected from column match table');
      throw Error('building name not selected from column match table');
    }
  };

  const prepareTenantInfo = ({
    rows,
    buildingId,
    requireBuildingNameColumn = false
  }: {
    rows: any[];
    buildingId?: string;
    requireBuildingNameColumn?: boolean;
  }) => {
    const finalData: TenantInfo[] = [];
    const fields: string[] = Object.keys(fieldMapping);

    checkIfEmailColumnIsSelected();
    if (requireBuildingNameColumn) {
      checkIfBuildingNameColumnIsSelected();
    }

    rows.forEach((row) => {
      let newRow: TenantInfo = { building: buildingId } as TenantInfo;

      // `id` is a client-only uniqueId() added for row-selection/React keys, not real
      // CSV data — never send it through to the backend as part of `details`.
      const details = { ...row, ...newRow, id: undefined };

      fields.forEach((field: string) => {
        const key = fieldMapping[field] as keyof TenantInfo;
        newRow[key] = row[field];
      });

      newRow = withFirstAndLastName(newRow);
      newRow.details = details;

      if (newRow.email) {
        finalData.push(newRow);
      }
    });

    return finalData;
  };

  return {
    fieldMapping,
    columnNameSelected,
    getTargetedRows,
    prepareTenantInfo
  };
};
